import './distributors.scss';
import { AjaxLoader } from '../../js/ajax-loader';
import { createElementFromHTML } from '../../js/helper';

class Distributors {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-distributors',
            fieldAttr: 'data-input',
            filterAttr: 'filter',
            contentAttr: 'content',
            tableAttr: 'table',
            resultAttr: 'result',
            sortAttr: '-sort',
            itemAttr: '-filteritem',
            loader: null,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$distributors = element;
        this.$header = document.querySelector('[data-header="root"]');
        this.$filter = null;
        this.$content = null;
        this.$table = null;
        this.$$tableRows = null;
        this.selectBox = null;

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }
    }

    initialize () {
        this.getDistributors(() => {
            this.$filter = this.$distributors.querySelector('[' + this.settings.initAttr + '="' + this.settings.filterAttr + '"]');
            this.$content = this.$distributors.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
            this.$table = this.$distributors.querySelector('[' + this.settings.initAttr + '="' + this.settings.tableAttr + '"]');
            this.$$tableRows = this.$table.querySelectorAll('[' + this.settings.initAttr + this.settings.itemAttr + ']');

            if (this.$filter !== null) {
                import('../../components/form/select-box').then(({ SelectBox }) => {
                    const selectBoxAPI = new SelectBox(this.$filter);
                    this.selectBox = selectBoxAPI.selectbox;

                    this.selectBox.on('selectr.init', () => {
                        this.$filter.API = this.selectBox;
                        this.setEvents();
                    });
                });
            }

            const $$tables = this.$distributors.querySelectorAll('.rte table');
            if ($$tables.length > 0) {
                import('../../components/scrolltable/scrolltable').then(({ Scrolltable }) => {
                    for (let i = 0; i < $$tables.length; i++) {
                        const $table = $$tables[i];
                        const scrolltableAPI = new Scrolltable($$tables[i]);
                        $table.API = scrolltableAPI;
                    }
                });
            }
        });
    }

    getDistributors (callback) {
        new AjaxLoader(this.$distributors.getAttribute('data-distributors-ajax'), { // eslint-disable-line
            requestMethod: 'GET',
            onSuccess: (result) => {
                const data = JSON.parse(result);
                const html = createElementFromHTML(data.html);

                if (html.length > 1) {
                    html.forEach((value) => {
                        this.$distributors.appendChild(value);
                    });
                } else {
                    this.$distributors.appendChild(html);
                }

                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    }

    sortColumn (columnIndex, direction) {
        const table = this.$table;
        const rows = table.rows;
        let switching = true;
        let i = 0;
        let shouldSwitch = false;
        let switchCount = 0;

        // Make a loop that will continue until no switching has been done:
        while (switching) {
            // start by saying: no switching is done:
            switching = false;
            // Loop through all table rows (except the first, which contains table headers):
            for (i = 1; i < (rows.length - 1); i++) {
                // start by saying there should be no switching:
                shouldSwitch = false;
                // Get the two elements you want to compare, one from current row and one from the next:
                const x = rows[i].querySelectorAll('td')[columnIndex];
                const y = rows[i + 1].querySelectorAll('td')[columnIndex];
                // check if the two rows should switch place, based on the direction, asc or desc:
                if (direction === 'asc') {
                    if (x.innerText.toLowerCase() > y.innerText.toLowerCase()) {
                        // if so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                } else if (direction === 'desc') {
                    if (x.innerText.toLowerCase() < y.innerText.toLowerCase()) {
                        // if so, mark as a switch and break the loop:
                        shouldSwitch = true;
                        break;
                    }
                }
            }

            if (shouldSwitch) {
                // If a switch has been marked, make the switch and mark that a switch has been done:
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                switchCount = switchCount + 1;
            }
        }

        return direction;
    }

    setEvents () {
        const $$sorters = this.$table.querySelectorAll('[' + this.settings.initAttr + this.settings.sortAttr + ']');

        for (let i = 0; i < $$sorters.length; i++) {
            const $sorter = $$sorters[i];

            $sorter.addEventListener('click', (e) => {
                let direction = $sorter.getAttribute(this.settings.initAttr + this.settings.sortAttr);
                if (direction === 'asc') {
                    direction = 'desc';
                } else {
                    direction = 'asc';
                }

                if (this.$loader) {
                    this.$table.parentNode.appendChild(this.$loader);
                }

                window.setTimeout(() => {
                    direction = this.sortColumn(i, direction);

                    this.toggleClasses($$sorters, ['asc', 'desc', 'is--active'], 'remove');
                    $sorter.classList.add(direction);
                    $sorter.classList.add('is--active');

                    if (this.$loader) {
                        this.$table.parentNode.removeChild(this.$loader);
                    }

                    $sorter.setAttribute(this.settings.initAttr + this.settings.sortAttr, direction);
                }, 150);
                e.preventDefault();
            });
        }

        this.selectBox.on('selectr.change', () => {
            this.toggleCountryRows(this.selectBox.getValue());
        });
    }

    toggleCountryRows (country) {
        if (country !== 'all') {
            this.toggleClasses(this.$$tableRows, 'is--hidden', 'add');

            const $$countryRows = this.$table.querySelectorAll('[' + this.settings.initAttr + this.settings.itemAttr + '="' + country + '"]');
            this.toggleClasses($$countryRows, 'is--hidden', 'remove');
        } else {
            this.toggleClasses(this.$$tableRows, 'is--hidden', 'remove');
        }
    }

    toggleClasses ($elements, className, toggle) {
        for (let i = 0; i < $elements.length; i++) {
            if (typeof className === 'object') {
                for (let c = 0; c < className.length; c++) {
                    if (toggle === 'remove') {
                        $elements[i].classList.remove(className[c]);
                    } else {
                        $elements[i].classList.add(className[c]);
                    }
                }
            } else {
                if (toggle === 'remove') {
                    $elements[i].classList.remove(className);
                } else {
                    $elements[i].classList.add(className);
                }
            }
        }
    }
}

export { Distributors };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$distributors = $context.querySelectorAll('[data-distributors="root"]');

        if ($$distributors.length > 0) {
            for (let i = 0; i < $$distributors.length; i++) {
                const $distributor = new Distributors($$distributors[i], {
                    loader: window.OPTIONS.loader
                });
                $distributor.initialize();
            }
        }
    }
});
